// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2RC_c","disabled":"FileBtn_disabled__KLkvU","warn":"FileBtn_warn__3zTRq","fade":"FileBtn_fade__1TT03"};